import PermissionModal from '../lib/PermissionModal';

const triggersSelector =
  'main a:not([href*="ana.co.jp"])[target="_blank"]:not([class*="-noPermissionModal"]), [id="v1-header"] ~ *:not([class="v1-footer"]):not([id="footer"]) a:not([href*="ana.co.jp"])[target="_blank"]:not([class*="-noPermissionModal"])';

/**
 * URL文字列が「//」始まりだったら「https」を追加する
 * @param {string} url
 * @returns
 */
function fixUrl(url) {
  if (url.startsWith('//')) {
    return `https:${url}`;
  }
  return url;
}

/**
 * HTMLのlang属性値を正規化する
 * @param {string} lang - HTMLのlang属性値
 * @returns {string} - 正規化された言語コード。langが「ja,en,de,fr,id,th,vi」のいずれかである場合は、末尾の「-」以降を削除した言語コードを返す。そうでない場合は、引数をそのまま返す。
 */
function normalizeLang(lang) {
  const langRegex = /^(ja|en|de|fr|id|th|vi)(-.*)?$/i;
  if (langRegex.test(lang)) {
    return lang.match(langRegex)[1];
  }
  return lang;
}

export default function v1Permission() {
  const triggers = document.querySelectorAll(triggersSelector);
  const langAttr = document.getElementsByTagName('html')[0].getAttribute('lang');
  const lang = normalizeLang(langAttr);
  const message = {
    ja: {
      note: 'ご注意：',
      text:
        'この先は外部サイトに移動します。利用規約やプライバシーポリシーは移動先サイトの方針が適用されます。サービスの手配や利用契約はお客様と移動先サイトとの間で成立し、ご利用に関するトラブル・損害についてANAは一切責任を負いません。',
      disagree: '同意しない',
      agree: '同意する',
    },
    en: {
      note: 'Note: ',
      text:
        'You will be moved to an external website. The terms of use and privacy policy adhere to the policies of the destination site. The arrangement and terms of use are agreed upon between the customer and the destination site. ANA is not responsible for any issues or damages that occur while using these services and products.',
      disagree: 'Disagree',
      agree: 'Agree',
    },
    'ko-kr': {
      note: '주의: ',
      text:
        '여기서부터는 외부 사이트로 이동합니다. 이용 약관 및 개인 정보 보호 방침은 이동한 사이트의 방침이 적용됩니다. 서비스의 준비 및 이용 계약은 고객과 이동한 사이트 간에 성립하며, 이용에 관한 문제 및 손해에 대해 ANA는 전혀 책임을 지지 않습니다.',
      disagree: '동의하지 않음',
      agree: '동의함',
    },
    'zh-CN': {
      note: '注意：',
      text:
        '下面将跳转至外部网站。使用协议和隐私政策适用跳转后网站的方针。服务提供及使用协议等事项均在您与跳转的网站之间成立，使用时如发生相关纠纷或损害时，ANA不承担任何责任。',
      disagree: '不同意',
      agree: '同意',
    },
    'zh-TW': {
      note: '注意：',
      text:
        '您將前往外部網站。使用規範及隱私保護政策將以該外部網站之規定為準。服務的安排、使用合約等內容係為旅客與該網站之間所合意成立。旅客使用商品時所產生的問題與損害，ANA 概不承擔任何責任。',
      disagree: '不同意',
      agree: '同意',
    },
    de: {
      note: 'Hinweis: ',
      text:
        'Sie werden nun auf die Webseite eines Drittanbieters weitergeleitet. Die Nutzungsbedingungen und Datenschutzrichtlinien für die externe Website entsprechen den dortigen Bestimmungen. Vereinbarungen und Nutzungsbedingungen gelten zwischen dem Kunden und der Zielwebsite. ANA kann nicht für Probleme oder Schäden verantwortlich gemacht werden, die während der Nutzung dieser Dienstleistungen und Produkte entstehen.',
      disagree: 'ablehnen',
      agree: 'zustimmen',
    },
    fr: {
      note: 'Remarque : ',
      text: `Vous allez accéder à un site internet externe. Les conditions d'utilisation et la politique de confidentialité sont conformes aux politiques du site de destination. Les dispositions et les conditions d'utilisation sont convenues entre le client et le site de destination. ANA n'est pas responsable des problèmes ou préjudices survenant pendant l'utilisation de ces services et produits.`,
      disagree: 'Je refuse',
      agree: "J'accepte",
    },
    id: {
      note: 'Catatan: ',
      text:
        'Anda sekarang akan diarahkan ke situs web eksternal. Syarat penggunaan dan kebijakan privasi akan mengikuti kebijakan situs tujuan. Pengaturan dan syarat penggunaan telah disepakati antara pelanggan dan situs tujuan. ANA tidak bertanggung jawab atas masalah atau kerusakan yang terjadi selama penggunaan layanan dan produk ini.',
      disagree: 'Tidak Setuju',
      agree: 'Setuju',
    },
    th: {
      note: 'หมายเหตุ: ',
      text:
        'ระบบจะนำท่านไปยังเว็บไซต์ภายนอก เงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัวเป็นไปตามนโยบายของเว็บไซต์ปลายทาง การจัดการและข้อกำหนดในการใช้นั้นได้รับความยินยอมระหว่างลูกค้าและเว็บไซต์ปลายทาง ANA จะไม่รับผิดชอบสำหรับปัญหาหรือความเสียหายใดๆ ที่เกิดขึ้นในระหว่างการใช้บริการและผลิตภัณฑ์เหล่านี้',
      disagree: 'ไม่ยอมรับ',
      agree: 'ยอมรับ',
    },
    'zh-HK': {
      note: '注意：',
      text:
        '您將轉至外部網站。使用條款及私隱政策遵守所訪問網站的政策。安排和使用條款由客戶與所訪問網站之間協定。ANA 對使用這些服務和產品過程中發生的任何問題或損害概不負責。',
      disagree: '不同意',
      agree: '同意',
    },
    vi: {
      note: 'Lưu ý: ',
      text:
        'Quý khách sẽ được chuyển sang một trang web bên ngoài. Điều khoản sử dụng và chính sách quyền riêng tư tuân thủ các chính sách của trang đích đến. Thỏa thuận và điều khoản sử dụng được thống nhất giữa khách hàng và trang đích đến. ANA không chịu trách nhiệm cho bất kỳ vấn đề hoặc thiệt hại nào xảy ra trong khi sử dụng các dịch vụ và sản phẩm này.',
      disagree: 'Không chấp nhận',
      agree: 'Chấp nhận',
    },
  };
  const { note, text, disagree, agree } = message[lang];
  const modalMessage = `
    <div style="display:none;">
      <div id="v1-permission-clone">
        <p class="v1-permission__text">
          <em class="v1-permission__notes">${note}</em>
          ${text}
        </p>
      </div>
    </div>
  `;
  const modalHTML = `
  <div class="v1-permission" id="v1-permission" aria-hidden="true">
    <div class="v1-permission__content" id="v1-permission-focus" role="dialog" aria-modal="true" tabindex="-1">
      <div class="v1-permission__inner">
        <div class="v1-permission__cloneContent" id="v1-permission-content"></div>
        <div class="v1-permission__footActions">
          <button type="button" id="v1-permission-disagree" class="v1-button v1-permission__button -disagree">${disagree}</button>
          <button type="button" id="v1-permission-agree" class="v1-button v1-permission__button -agree">${agree}<svg class="v1-permission__buttonBlank js-external-link" role="note" focusable="false"><use xlink:href="/japan-travel-planner/common/svg/sprite.svg#blank"></use></svg></button>
        </div>
      </div>
    </div>
    <div class="v1-permission__overlay" id="v1-permission-overlay"></div>
  </div>
  `;

  window.addEventListener('DOMContentLoaded', () => {
    if (triggers.length) {
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalMessage);
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', modalHTML);
    }
  });

  window.addEventListener('load', () => {
    if (triggers.length) {
      const permissionModal = new PermissionModal({
        trigger: triggersSelector,
        beforeAgree(_, url) {
          // `window.open()`内に直接指定すると、Safariで別ウィンドウによって表示されてしまう
          const windowOpen = window.open();
          windowOpen.opener = null;
          windowOpen.location = url;
        },
      });
      permissionModal.init();

      const windowOpen = event => {
        event.preventDefault();
        const href = event.target.closest('a');
        const url = fixUrl(href.getAttribute('href'));
        permissionModal.open(url);
      };

      Array.from(triggers).forEach(trigger => {
        trigger.addEventListener('click', windowOpen);
      });
    }
  });
}
